import { render, staticRenderFns } from "./UserCus.vue?vue&type=template&id=6078b51b&scoped=true&"
import script from "./UserCus.vue?vue&type=script&lang=js&"
export * from "./UserCus.vue?vue&type=script&lang=js&"
import style0 from "./UserCus.vue?vue&type=style&index=0&id=6078b51b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078b51b",
  null
  
)

export default component.exports